import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "competition-standings" }
const _hoisted_2 = {
  key: 1,
  class: "competition-standings-body"
}

import isNil from 'lodash/isNil'
import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { CompetitionTeamStandingsSlip } from '@/store/public/competition.types'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompetitionStandingsTeam',
  props: {
  slip: {
    type: Object as PropType<CompetitionTeamStandingsSlip | null>,
    default: null,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isNil)(__props.slip) || _unref(isNil)(__props.slip.teams) || __props.slip.teams.length === 0)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: _ctx.$t('competition-standings.empty-results')
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-team')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-bowlers')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-team-score')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-score')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-handicap')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('competition-standings.heading-average')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slip.teams, (team, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(1 + index), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatValue)(team.name)), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[0] || (_cache[0] = _createElementVNode("small", null, " ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.members, (member, j) => {
                  return (_openBlock(), _createElementBlock("small", {
                    key: `member-${index}-${j}`
                  }, _toDisplayString(member.fullName), 1))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(team.score, 0)), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createElementVNode("small", null, " ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.members, (member, j) => {
                  return (_openBlock(), _createElementBlock("small", {
                    key: `score-${index}-${j}`
                  }, _toDisplayString(_unref(formatFloat)(member.score, 0)), 1))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _cache[2] || (_cache[2] = _createElementVNode("small", null, " ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.members, (member, j) => {
                  return (_openBlock(), _createElementBlock("small", {
                    key: `handicap-${index}-${j}`
                  }, _toDisplayString(_unref(formatFloat)(member.handicap, 0)), 1))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("small", null, _toDisplayString(_unref(formatFloat)(team.average, 2)), 1)
              ])
            ], 64))
          }), 128))
        ]))
  ]))
}
}

})